import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import * as ToastManagement from './ToastManagement';

export default function configureStore(initialState) {
  const reducers = {
    toastManagement: ToastManagement.reducer
  };

  const middleware = [thunk];

  const rootreducer = combineReducers({
    ...reducers
  });

  const composeEnhancers =
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    rootreducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware))
  );
}
